<script>
  import { notification } from "../store.js";
  import Action from "./Action.svelte";
  import TextField from "../utils/TextField.svelte";
  import { actions } from "../constants.js";
  
  export let error;

  const addButton = () =>
    notification.update("buttons", [
      ...$notification.buttons,
      { idx: $notification.buttons.length, text: "", action: "", url: "" },
    ]);

  const deleteButton = idx =>
    notification.update(
      "buttons",
      $notification.buttons.filter((_, index) => index != idx)
		);
	
  const options = actions.map(i => i.option);
</script>

<style>
  .button-wrapper {
    margin-bottom: 12px;
  }
  .delete-button {
    margin-top: 4px;
  }
</style>

<div class="button-wrapper">
  <label class="label is-small">Buttons <span class="has-text-grey has-text-weight-light"> *not supported by all browsers</span></label>

  {#each $notification.buttons as button, idx}
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <button
            class="button is-outlined delete-button"
            on:click={() => deleteButton(idx)}>
            <i class="fas fa-trash" />
          </button>
        </div>

        <div class="level-item">
          <div class="control">
            <TextField
              title=""
              placeholder="button text"
              bind:value={button.text} 
              error={(error[idx] || {}).text}
              />
          </div>
        </div>

        <div class="level-item">
          <Action
            {options}
            bind:value={button.action}
            bind:url={button.url}
            defaultValue={options[1].value} 
            error={error[idx] || {}}
            />
        </div>
      </div>
    </div>
  {/each}

  {#if $notification.buttons.length <= 1}
    <button class="button is-outlined" on:click={addButton}>
      Add Button &nbsp;
      <i class="fas fa-plus" />
    </button>
  {/if}
</div>
